import EmptyIcon from 'Assets/icons/empty-icon.svg'
import styles from './EmptyStaleIndicator.module.less'

export type EmptyStateIndicatorProps = {
    icon?: string
    label?: string
    caption: string
}

export const EmptyStateIndicator: React.FC<EmptyStateIndicatorProps> = (
    props: EmptyStateIndicatorProps
) => {
    return (
        <div className={styles['empty']} data-testid="empty-wrapper">
            <img className={styles['empty-icon']} src={props.icon ?? EmptyIcon} alt="Empty" />
            {props.label && <span className={styles['empty-text']}>{props.label}</span>}
            <span className={styles['empty-caption']}>{props.caption}</span>
        </div>
    )
}
